import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function MessageChat({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M7.07816 21.808C9.77816 21.808 11.9782 19.608 11.9782 16.904C11.9702 14.196 9.77016 12 7.07016 12C4.36016 12 2.16616 14.19 2.16616 16.904M7.08316 21.813C6.34316 21.813 5.64316 21.643 5.01316 21.353L1.99316 21.993L2.62316 18.963C2.32316 18.333 2.16316 17.623 2.16316 16.883M6.55716 12.02C6.19716 11.19 5.99716 10.3 5.99716 9.35999C5.99716 5.33999 9.58716 2.12 13.9972 2.12C18.3972 2.12 21.9972 5.33999 21.9972 9.35999C21.9972 11.73 20.7272 13.824 18.7972 15.142C18.7972 15.892 18.7872 16.912 18.7872 17.982L15.6472 16.432C15.1072 16.532 14.5472 16.582 13.9772 16.582C13.2672 16.582 12.5772 16.492 11.9272 16.332" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default MessageChat;